<t4-header icon="glyphicon-stats">
</t4-header>
<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<t4-container>


  <ng-container toolbar>
  </ng-container>
  <t4-data-table #securityCheckTable [rawData]="rawData" headline="" matSort [allowExcel]="false" [allowPaging]="true" [allowFilter]="true" [autoGenerateColumns]="false" [filterFields]="['Item1.Title', 'Item1.RentalLocation.Name']">

    <ng-container matColumnDef="Title">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">RegNo</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;"><t4-object-link objectId="{{row.Item1.Id}}">{{ row.Item1.Title }}</t4-object-link></mat-cell>
    </ng-container>

    <ng-container matColumnDef="Locatiom">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">Location</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;"><t4-location-link locationId="{{row.Item1.RentalLocation.Id}}">{{ row.Item1.RentalLocation.Name }}</t4-location-link></mat-cell>
    </ng-container>

    <ng-container matColumnDef="Message">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">Message</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ row.Item2 }}</mat-cell>
    </ng-container>

  </t4-data-table>
</t4-container>

